import { loadStripe } from '@stripe/stripe-js';

import { isProd } from '../../../config/config';
import { TRASHIE_STRIPE_PUBLIC_KEY } from '../config/config';

const getStripePromise = () => loadStripe(
  isProd()
    ? TRASHIE_STRIPE_PUBLIC_KEY.PRODUCTION
    : TRASHIE_STRIPE_PUBLIC_KEY.TEST,
);

export default getStripePromise;
